import { VApp } from 'vuetify/lib/components/VApp';
import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    {
      ref: "lpu-services-pagination",
      attrs: { "data-lpu-services-pagination": "" },
    },
    [
      _c(VPagination, {
        class: _vm.isMobile ? "py-6 mx-n2 bg-secondary" : "pt-2",
        attrs: {
          "total-visible": _vm.isMobile ? 5 : 7,
          length: _vm.pageCount,
          circle: "",
        },
        on: { input: _vm.emitRelocatePage },
        model: {
          value: _vm.paginationModel,
          callback: function ($$v) {
            _vm.paginationModel = $$v
          },
          expression: "paginationModel",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }